/*
 *
 * Spreadsheet constants
 *
 */

export const SLICE_NAME = 'spreadsheet';
